module.exports = __webpack_public_path__ + "img/cropped-headshot-small.d40900e2.png";